import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/_base/_auth/customers/segments/")({
  component: () => <Navigate to="/customers/segments/list" replace />,
})
